import { useEffect, useState } from "react";
import { getOnlyFranchisePub } from "../../../../../../../api/cafe";
import {
  FranchisePubPopupBox,
  FranchisePubPopupButtonWrapper,
  FranchisePubPopupItem,
  FranchisePubPopupLeftButton,
  FranchisePubPopupListWrapper,
  FranchisePubPopupRightButton,
  FranchisePubPopupTitle,
  FranchisePubPopupWrapper,
} from "./styles";
import { Cafe } from "../../../../../../../api/types";
import { getDistanceKm } from "../../../../../../../utils/common";
import { useWalletContext } from "../../../../hooks/wallet-context";
import { WalletTab } from "../../../../hooks/use-wallet-tab";
import useGeoLocation from "../../../../../../../hooks/useGeoLocation";

const FranchisePubPopup = () => {
  const [pubList, setPubList] = useState<Cafe[]>([]);
  const [selectedPub, setSelectedPub] = useState<Cafe | null>(null);
  const { latitude, longitude } = useGeoLocation();
  const { setSelectedFranchisePub, setIsFranchisePubOpen, setWalletTab } =
    useWalletContext();

  useEffect(() => {
    getOnlyFranchisePub(latitude, longitude).then((res) => {
      setPubList(res.list);
      setSelectedPub(res.list[0]);
    });
  }, []);

  return (
    <FranchisePubPopupWrapper>
      <FranchisePubPopupBox>
        <FranchisePubPopupTitle>매장 설정</FranchisePubPopupTitle>
        <FranchisePubPopupListWrapper>
          {pubList.map((pub) => (
            <FranchisePubPopupItem
              key={pub.id}
              selected={selectedPub?.id === pub.id}
              onClick={() => setSelectedPub(pub)}
            >
              <div className="pub">{pub.cafeName}</div>
              <div className="distance">
                {getDistanceKm(latitude, longitude, pub.lat, pub.lon)} km
              </div>
            </FranchisePubPopupItem>
          ))}
        </FranchisePubPopupListWrapper>
        <FranchisePubPopupButtonWrapper>
          <FranchisePubPopupLeftButton
            onClick={() => setIsFranchisePubOpen(false)}
          >
            취소
          </FranchisePubPopupLeftButton>
          <FranchisePubPopupRightButton
            onClick={() => {
              setSelectedFranchisePub(selectedPub);
              setIsFranchisePubOpen(false);
              setWalletTab(WalletTab.ORDER);
            }}
          >
            확인
          </FranchisePubPopupRightButton>
        </FranchisePubPopupButtonWrapper>
      </FranchisePubPopupBox>
    </FranchisePubPopupWrapper>
  );
};

export default FranchisePubPopup;
